import { quoteQuery } from "@common/api/quoting/quote"
import { useHasPermission } from "@common/hooks/use-permissions"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SendPane } from "./-components/send-pane"
import { useReviewEnabled } from "./-lib/dispositions"
import { canSend } from "./-lib/review-flow"

export const Route = createFileRoute("/_layout/quotes_/$quoteId/send")({
  component: SendPaneRoute,
})

function SendPaneRoute(): React.ReactElement {
  const { quoteId } = Route.useParams()
  const { data: quote } = useSuspenseQuery(quoteQuery({ quote_id: quoteId }))
  const canUpdate = useHasPermission("quote:update")
  const reviewing = useReviewEnabled()
  const stage = quote.disposition
  const sendingStage =
    stage === "review" ||
    stage === "customer_response" ||
    (stage === "draft" && !reviewing)
  const sendable = sendingStage && canSend(quote)

  if (!canUpdate || !sendable) {
    return (
      <Navigate
        from={Route.fullPath}
        to="/quotes/$quoteId"
        params={{ quoteId }}
        search={(previous) => ({ ...previous, preview: undefined })}
        replace
      />
    )
  }

  return <SendPane quote={quote} />
}
